import CaseIcon from './../../img/icons/icon-briefcase.svg'
import ExtIcon from './../../img/icons/icon-external-link.svg'

Drupal.behaviors.brandCountriesSelector = {
  attach: function (context, settings) {
    once('brandCountriesSelector', '.js-brand-countries-selector', context).forEach(function (element) {
      const rowsContainer = element.querySelector('.js-countries-rows');
      const countries = rowsContainer.querySelectorAll('.views-field-field-country a');
      const websites = rowsContainer.querySelectorAll('.views-field-field-website a');
      const numberOfRows = countries.length;
      const select = document.createElement('select');
      let countryWebsite = {};
      for(let i = 0; i < numberOfRows; i++) {
        let countryName = countries[i].innerText;
        countryWebsite[countryName] = websites[i].getAttribute('href');

        let option = document.createElement('option');
        option.setAttribute('value', countryName);
        option.innerText = countryName;
        select.appendChild(option);
      }

      const websiteButton = document.createElement('a');
      websiteButton.setAttribute('href', websites[0].getAttribute('href'));
      websiteButton.classList.add('btn', 'btn-primary', 'w-100');
      websiteButton.innerText = Drupal.t('Visit Brand Webiste');

      const extIconImg = new Image();
      extIconImg.src = ExtIcon;
      websiteButton.appendChild(extIconImg);

      const jobButton = document.createElement('a');
      jobButton.setAttribute('href', 'https://careeratamrest.com/');
      jobButton.classList.add('btn', 'btn-secondary', 'w-100');
      jobButton.innerText = Drupal.t('Job Opportunities');

      const caseIconImg = new Image();
      caseIconImg.src = CaseIcon;
      jobButton.appendChild(caseIconImg);

      const label = document.createElement('label');
      label.innerText = Drupal.t('Select country');
      label.setAttribute('for', 'country-select');

      select.setAttribute('id', 'country-select');
      select.classList.add('form-select', 'form-control');

      const selectWrapper = document.createElement('div');
      selectWrapper.classList.add('form--select-wrapper');
      selectWrapper.addEventListener('change', function (e) {
        const chosenCountry = e.target.value;
        const countryLink = this.countries[chosenCountry];
        websiteButton.setAttribute('href', countryLink);
      }.bind({countries:  countryWebsite, websiteButton: websiteButton}))

      selectWrapper.appendChild(label);
      selectWrapper.appendChild(select);

      element.appendChild(selectWrapper);
      element.appendChild(websiteButton);
      element.appendChild(jobButton);

    });
  },
};
